import { Component, Input, OnInit } from '@angular/core';
import { Tie } from '../../../_shared/models/tie.model';
import { forEach } from 'lodash-es';

@Component({
  standalone: false,
  selector: 'app-league-draw',
  templateUrl: './league-draw.component.html',
  styleUrls: ['./league-draw.component.scss'],
})
export class LeagueDrawComponent  implements OnInit {

  @Input({ required: true }) ties: Tie[];

  rounds: any[] = [];

  ngOnInit() {
    this.groupTies() 
  }

  private groupTies() {
    this.rounds.push(this.ties.filter(t => t.roundNumber === 1));
    this.rounds.push(this.ties.filter(t => t.roundNumber === 2))
    this.rounds.push(this.ties.filter(t => t.roundNumber === 3))
    this.rounds.forEach(r => { r = r.sort((a, b) => a.roundPosition - b.roundPosition) });
  }

  drawMarginTop(roundNumber: number, roundPosition: number): number {
    if (roundNumber === 2) {
      return roundPosition * 158 / 2 + 6
    } else if (roundNumber === 3) {
      return roundNumber* roundPosition * 158 / 2 + 6;
    }
  }

  drawMarginBottom(roundNumber: number, roundPosition: number): number {
    return (roundNumber - 1) * roundPosition * 158/2
  }
  

}
